import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import i18n from '@/i18n'
import { isChunkLoadFailure, reloadForStaleChunk } from '@/lib/chunk-load-recovery'
import { ErrorPage } from './error-page'

export function RouteErrorFallback() {
  const error = useRouteError()
  const chunkStale = isChunkLoadFailure(error)

  if (!chunkStale && isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <ErrorPage type="not-found" />
    }
    if (error.status === 401 || error.status === 403) {
      return <ErrorPage type="unauthorized" />
    }
  }

  return (
    <ErrorPage
      type="generic"
      title={chunkStale ? i18n.t('error.chunkOutdated.title') : undefined}
      message={chunkStale ? i18n.t('error.chunkOutdated.message') : undefined}
      onRetry={() => {
        if (chunkStale) {
          reloadForStaleChunk({ force: true })
          return
        }
        window.location.reload()
      }}
    />
  )
}
